import axios from "axios";
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const api = axios.create({ baseURL: API });
api.interceptors.request.use((cfg) => {
  const t = localStorage.getItem("vsq_token");
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});
export const fmtM = (v) => {
  if (v == null) return "-";
  const n = Number(v);
  if (Math.abs(n) >= 1e6) return `$${(n / 1e6).toFixed(1)}M`;
  if (Math.abs(n) >= 1e3) return `$${(n / 1e3).toFixed(0)}K`;
  return `$${n.toLocaleString()}`;
};
export const fmtFull = (v) => (v == null ? "-" : `$${Number(v).toLocaleString()}`);
